import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf, VariablesOf } from 'gql.tada';

// Deletes a selection of draft invoices that may span families. The backend
// runs each family on its own; a non-draft row in the selection is left alone
// and reported as skipped.
const DeleteSchoolDraftsMutation = graphql.persisted(
  "DeleteSchoolDrafts",
  graphql(`
    mutation DeleteSchoolDrafts($input: DeleteSchoolDraftsInput!) {
      deleteSchoolDrafts(input: $input) {
        success
        familyCount
        deletedCount
        families {
          familyEnrollmentId
          familyName
          deletedCount
          message
          rows {
            invoiceId
            action
            message
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export type DeleteSchoolDraftsInput = VariablesOf<typeof DeleteSchoolDraftsMutation>['input'];
export type DeleteSchoolDraftsPayload = NonNullable<
  ResultOf<typeof DeleteSchoolDraftsMutation>['deleteSchoolDrafts']
>;
export type DeleteSchoolDraftsFamily = DeleteSchoolDraftsPayload['families'][number];

export { DeleteSchoolDraftsMutation };

export function useDeleteSchoolDrafts() {
  return useMutation(DeleteSchoolDraftsMutation);
}
